export default __webpack_public_path__ + "locales/uk-UA/RoomLogoCover.json?hash=0a335b1dc91930b7499a78f4bb2b0892";